import React, { useEffect, useState } from "react";
import Footer from "../footer/Footer";
import Header from "../dashboard/Header";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoginRedirection from "../../Service/LoginRedirection";
import { message } from "antd";
import TokenUndefined from "../../Service/TokenUndefined";

const DashBoard = () => {
  const [unpaidRequest, setunPaidRequest] = useState("");
  const [paidRequest, setPaidRequest] = useState("");
  const [freeVisitorRequest, setFreeVisitorRequest] = useState("");
  const [visitorRequest, setVisitorRequest] = useState("");
  const [visitorHold, setVisitorHold] = useState("");
  const [visitorReject, setVisitorReject] = useState("");
  const [agentUnapproved, setAgentUnapproved] = useState("");
  const [agentApproved, setAgentApproved] = useState("");
  const [exhibitorOwner, setExhibitorOwner] = useState("");
  const [exhibitorStaff, setExhibitorStaff] = useState("");
  const [vendorOwner, setVendorOwner] = useState("");
  const [vendorStaff, setVendorStaff] = useState("");
  const [vipRequest, setVipRequest] = useState("");
  const [vipApproved, setVipApproved] = useState("");
  const [vipRejected, setVipRejected] = useState("");
  const [allExhibitor, setAllExhibitor] = useState("");
  const [allVendor, setAllVendor] = useState("");
  const [ofaVisitor, setOfaVisitor] = useState("");
  const [nfaVisitor, setNfaVisitor] = useState("");
  const [ofaBookedVisitor, setOfaBookedVisitor] = useState("");
  const [nfaBookedVisitor, setNfaBookedVisitor] = useState("");
  const [VisitorApproved, setVisitorApproved] = useState("");
    const [VisitorHAR, setVisitorHAR] = useState({
    freeVisitorAccepted: "",
    unpaidVisitorAccepted: "",
    paidVisitorAccepted: "",
  });
  const [roomCount, setRoomCount] = useState();
  const [roomCountApproved, setRoomCountApproved] = useState();
  const [spinner, setSpinner] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/exhibitor-dashboard`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        console.log("asadsadssadsdasd", res.data);
        setunPaidRequest(res.data.unpaidRequest);
        setPaidRequest(res.data.paidRequest);
        setFreeVisitorRequest(res.data.freeVisitorRequest);
        setVisitorRequest(res.data.visitorRequest);
        setVisitorHold(res.data.visitorHold);
        setVisitorReject(res.data.visitorReject);
        setAgentUnapproved(res.data.agentUnapproved);
        setExhibitorOwner(res.data.exhibitorOwner);
        setExhibitorStaff(res.data.exhibitorStaff);
        setVendorOwner(res.data.vendorOwner);
        setAgentApproved(res.data.agentApproved);
        setVendorStaff(res.data.vendorStaff);
        setVipRequest(res.data.vipRequest);
        setVipApproved(res.data.vipApproved);
        setVipRejected(res.data.vipRejected);
        setAllExhibitor(res.data.allExhibitor);
        setAllVendor(res.data.allVendor);
        setOfaVisitor(res.data.ofaVisitor);
        setNfaVisitor(res.data.nfaVisitor);
        setOfaBookedVisitor(res.data.ofaBookedVisitor);
        setNfaBookedVisitor(res.data.nfaBookedVisitor);
        setVisitorApproved(res.data.acceptedVisitor);
        setRoomCount(res.data.roomCount);
        setRoomCountApproved(res.data.roomCountApproved);
        setVisitorHAR(prev => ({
          ...prev,
          freeVisitorAccepted: res.data.freeVisitorAccepted,
          unpaidVisitorAccepted: res.data.unpaidVisitorAccepted,
          paidVisitorAccepted: res.data.paidVisitorAccepted,
        }));

        console.log(roomCount);
        console.log(roomCountApproved);
        // set visitorAllCount from API — support multiple possible property names as fallback
        // Prefer explicit "visitorAll" if backend returns it; otherwise use visitorRequest (all pending),
        // or use sum of paid+unpaid as a last resort if those exist.
        const apiVisitorAll =
          res.data.visitorAll ??
          res.data.allVisitor ??
          res.data.totalVisitors ??
          (res.data.paidRequest != null && res.data.unpaidRequest != null
            ? res.data.paidRequest + res.data.unpaidRequest
            : null) ??
          res.data.visitorRequest ??
          "";
        

        setSpinner(false);
      })
      .catch((err) => {
        // LoginRedirection("/superadmin/login");
        console.log("aadssadsdsda", err);
        if (err.response && err.response.status === 401) {
          navigate("/superadmin/login");
          localStorage.removeItem("jff_token");
          localStorage.removeItem("category");
          localStorage.removeItem("permission");
          localStorage.removeItem("user_id");
          localStorage.removeItem("type_of_user");
        }
      });
  }, []);

  const downloadAllList = () => {
    TokenUndefined("superadmin/login");
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/download-all-data`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        LoginRedirection(res, "superadmin/login");
        message.success("Success");
        const link = `${process.env.REACT_APP_API_END_POINT}/download-all-data`;
        window.location.href = link;
      })
      .catch((err) => {
        // LoginRedirection("/superadmin/login");
        if (err.response && err.response.status === 401) {
          navigate("/superadmin/login");
          localStorage.removeItem("jff_token");
          localStorage.removeItem("category");
          localStorage.removeItem("permission");
          localStorage.removeItem("user_id");
          localStorage.removeItem("type_of_user");
        }
      });
  };
  return (
    <>
      <Header />
      {spinner ? (
        <>
          <div className="content-height d-flex align-items-center justify-content-center">
            <div
              className="spinner-border text-center"
              style={{ width: " 3rem", height: " 3rem" }}
              role="status"
            ></div>
          </div>
        </>
      ) : (
        <div className="content-height">
          <div className="text-center">
            <h2 className="form-heading">Super Admin DashBoard</h2>
          </div>

          {/* <div>
            <button
              className="btn btn-outline-success ms-3"
              type="submit"
              onClick={() => downloadAllList()}
            >
              Download All List
            </button>
          </div> */}
          <div className="container text-center my-2">
            <div className="mb-5 p-5">
              <div className="row" style={{ gap: "20px 0px" }}>
                {/* <div className="col-lg-6">
                <div className="p-3 border">
                  <p className="fw-bold fs-4 my-1">VIP Guest (DAY 1)</p>
                  <div className="container text-center my-2">
                    <div className="row" style={{ backgroundColor: "#000000" }}>
                      <div className="col border border-white text-white">
                        Request{" "}
                      </div>
                      <div className="col border border-white text-white">
                        Invited
                      </div>
                      <div className="col border border-white text-white">
                        Pending
                      </div>
                    </div>
                    <div className="row" style={{ backgroundColor: "#e2e8f0" }}>
                      <div className="col border border-white">0</div>
                      <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div>
                    </div>
                  </div>
                </div>
              </div> */}
                {/* <div className="col-lg-6">
                <div className="p-3 border">
                  <p className="fw-bold fs-4 my-1">VIP Guest (Day 2)</p>
                  <div className="container text-center my-2">
                    <div className="row" style={{ backgroundColor: "#000000" }}>
                      <div className="col border border-white text-white">
                        Request{" "}
                      </div>
                      <div className="col border border-white text-white">
                        Invited
                      </div>
                      <div className="col border border-white text-white">
                        Pending
                      </div>
                    </div>
                    <div className="row" style={{ backgroundColor: "#e2e8f0" }}>
                      <div className="col border border-white">0</div>
                      <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div>
                    </div>
                  </div>
                </div>
              </div> */}

                {/* <div className="col-lg-6">
                <div className="p-3 border">
                  <p className="fw-bold fs-4 my-1">Exhibitor</p>
                  <div className="container text-center my-2">
                    <div className="row" style={{ backgroundColor: "#000000" }}>
                      <div className="col border border-white text-white">
                        Registered Owner
                      </div>
                      <div className="col border border-white text-white">
                        Approved Owners{" "}
                      </div>
                      <div className="col border border-white text-white">
                        Pending Owners
                      </div>
                    </div>
                    <div className="row" style={{ backgroundColor: "#e2e8f0" }}>
                      <div className="col border border-white">
                        {" "}
                        {exhibitorOwner ? exhibitorOwner : "0"}
                      </div>
                      <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div>
                    </div>
                  </div>
                </div>
              </div> */}
                {/* <div className="col-lg-6">
                  <div className="p-3 border">
                    <p className="fw-bold fs-4 my-1">Exhibitor</p>
                    <div className="container text-center my-2">
                      <div
                        className="row"
                        style={{ backgroundColor: "#000000" }}
                      >
                        <div className="col border border-white text-white">
                          All Exhibitor
                        </div>
                        <div className="col border border-white text-white">
                          Registered Owner
                        </div>
                        <div className="col border border-white text-white">
                          Registered Staff
                        </div>

                         <div className="col border border-white text-white">
                        Approved Staff
                      </div>
                      <div className="col border border-white text-white">
                        Pending Staff
                      </div> 
                      </div>
                      <div
                        className="row"
                        style={{ backgroundColor: "#e2e8f0" }}
                      >
                        <div className="col border border-white">
                          {" "}
                          {allExhibitor ? allExhibitor : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {exhibitorOwner ? exhibitorOwner : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {exhibitorStaff ? exhibitorStaff : "0"}
                        </div>
                         <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div> 
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <div className="col-lg-6">
                  <div className="p-3 border">
                    <p className="fw-bold fs-4 my-1">Vendor</p>
                    <div className="container text-center my-2">
                      <div
                        className="row"
                        style={{ backgroundColor: "#000000" }}
                      >
                        {" "}
                        <div className="col border border-white text-white">
                          All Vendor
                        </div>
                        <div className="col border border-white text-white">
                          Registered Owner
                        </div>
                        <div className="col border border-white text-white">
                        Approved Owners{" "}
                      </div>
                      <div className="col border border-white text-white">
                        Pending Owners
                      </div>
                        <div className="col border border-white text-white">
                          Registered Staff
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ backgroundColor: "#e2e8f0" }}
                      >
                        <div className="col border border-white">
                          {" "}
                          {allVendor ? allVendor : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {vendorOwner ? vendorOwner : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {vendorStaff ? vendorStaff : "0"}
                        </div>
                         <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div> 
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* MADE WIDTH LIKE BUYER - changed to col-lg-12 */}
                <div className="col-lg-12">
                  <div className="p-3 border">
                    <p className="fw-bold fs-4 my-1">Visitor</p>
                    <div className="container text-center my-2">
                      <div className="row" style={{ backgroundColor: "#000000" }}>
                        <div className="col-3 border border-white text-white">
                          <div>
                            Request{" "}
                            <span className="small ms-2" style={{ opacity: 0.9 }}>
                              (All)
                            </span>
                          </div>
                        </div>
                        <div className="col-3 border border-white text-white">Hold</div>
                        <div className="col-3 border border-white text-white">Accepted</div>
                        <div className="col-3 border border-white text-white">Rejected</div>
                      </div>
                      <div className="row" style={{ backgroundColor: "#e2e8f0" }}>
                        <div className="col-3 border border-white">
                          {/* Show All count above the unpaid/paid split */}
                          <div className="fw-bold">{visitorRequest ?? "0"}</div>
                          <div>
                            <div className="row" style={{ backgroundColor: "#000" }}>
                              <div className="col-4 border-top border-end border-white text-white small">Unpaid</div>
                              <div className="col-4 border-top border-end border-white text-white small">Paid</div>
                              <div className="col-4 border-top border-white text-white small">Free</div>
                            </div>
                            <div className="row mt-1">
                              <div className="col-4 border-end border-white">
                                {unpaidRequest ?? "0"}
                              </div>
                               <div className="col-4 border-end border-white">
                                {paidRequest ?? "0"}
                              </div>
                              <div className="col-4">{freeVisitorRequest ?? "0"}</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-3 border border-white">{visitorHold ?? "0"}</div>
                        <div className="col-3 border border-white">{VisitorApproved ?? "0"}
                          <div>
                            <div className="row" style={{ backgroundColor: "#000" }}>
                              <div className="col-4 border-top border-end border-white text-white small">Unpaid</div>
                              <div className="col-4 border-top border-end border-white text-white small">Paid</div>
                              <div className="col-4 border-top border-white text-white small">Free</div>
                            </div>
                            <div className="row mt-1">
                              <div className="col-4 border-end border-white">
                                {VisitorHAR.unpaidVisitorAccepted ?? "0"}
                              </div>
                              <div className="col-4 border-end border-white">
                                {VisitorHAR.paidVisitorAccepted ?? "0"}
                              </div>
                              <div className="col-4">{VisitorHAR.freeVisitorAccepted ?? "0"}</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-3 border border-white">{visitorReject ?? "0"}</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-lg-6">
                  <div className="p-3 border">
                    <p className="fw-bold fs-4 my-1">Agent</p>
                    <div className="container text-center my-2">
                      <div
                        className="row"
                        style={{ backgroundColor: "#000000" }}
                      >
                        <div className="col border border-white text-white">
                          Registered
                        </div> 
                        <div className="col border border-white text-white">
                          Approved
                        </div>
                        <div className="col border border-white text-white">
                          Unapproved
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ backgroundColor: "#e2e8f0" }}
                      >
                        <div className="col border border-white">
                          {" "}
                          {visitorReject ? visitorReject : "0"}
                        </div> 
                        <div className="col border border-white">
                          {" "}
                          {agentApproved ? agentApproved : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {agentUnapproved ? agentUnapproved : "0"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="col-lg-12">
                  <div className="p-3 border">
                    <p className="fw-bold fs-4 my-1">Buyer</p>
                    <div className="container text-center my-2">
                      <div
                        className="row"
                        style={{ backgroundColor: "#000000" }}
                      >
                        {" "}
                        <div className="col border border-white text-white">
                          Buyer Request
                        </div>
                        <div className="col border border-white text-white">
                          Buyer Approved
                        </div>
                        {/* <div className="col border border-white text-white">
                        Approved Owners{" "}
                      </div>
                      <div className="col border border-white text-white">
                        Pending Owners
                      </div> */}
                        <div className="col border border-white text-white">
                          Buyer Rejected
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ backgroundColor: "#e2e8f0" }}
                      >
                        <div className="col border border-white">
                          {" "}
                          {vipRequest ? vipRequest : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {vipApproved ? vipApproved : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {vipRejected ? vipRejected : "0"}
                        </div>
                        {/* <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div> */}
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="p-3 border col-lg-6">
                        <p className="fw-bold fs-4 my-1">Flight</p>
                        <div className="container text-center my-2">
                          <div
                            className="row"
                            style={{ backgroundColor: "#000000" }}
                          >
                            {" "}
                            <div className="col border border-white text-white">
                              Assigned
                            </div>
                            <div className="col border border-white text-white">
                              Booked
                            </div>
                            {/* <div className="col border border-white text-white">
                        Approved Owners{" "}
                      </div>
                      <div className="col border border-white text-white">
                        Pending Owners
                      </div> */}
                            {/* <div className="col border border-white text-white">
                            Buyer Rejected
                          </div> */}
                          </div>
                          <div
                            className="row"
                            style={{ backgroundColor: "#e2e8f0" }}
                          >
                            <div className="col border border-white">
                              {" "}
                              {ofaVisitor ? ofaVisitor : "0"}
                            </div>
                            <div className="col border border-white">
                              {" "}
                              {ofaBookedVisitor ? ofaBookedVisitor : "0"}
                            </div>
                            {/* <div className="col border border-white">
                            {" "}
                            {vipRejected ? vipRejected : "0"}
                          </div> */}
                            {/* <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div> */}
                          </div>
                        </div>
                      </div>
                      <div className="p-3 border col-lg-6">
                        <p className="fw-bold fs-4 my-1">Flight 2</p>
                        <div className="container text-center my-2">
                          <div
                            className="row"
                            style={{ backgroundColor: "#000000" }}
                          >
                            {" "}
                            <div className="col border border-white text-white">
                              Assigned
                            </div>
                            <div className="col border border-white text-white">
                              Booked
                            </div>
                            {/* <div className="col border border-white text-white">
                        Approved Owners{" "}
                      </div>
                      <div className="col border border-white text-white">
                        Pending Owners
                      </div> */}
                            {/* <div className="col border border-white text-white">
                            Buyer Rejected
                          </div> */}
                          </div>
                          <div
                            className="row"
                            style={{ backgroundColor: "#e2e8f0" }}
                          >
                            <div className="col border border-white">
                              {" "}
                              {nfaVisitor ? nfaVisitor : "0"}
                            </div>
                            <div className="col border border-white">
                              {" "}
                              {nfaBookedVisitor ? nfaBookedVisitor : "0"}
                            </div>
                            {/* <div className="col border border-white">
                            {" "}
                            {vipRejected ? vipRejected : "0"}
                          </div> */}
                            {/* <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="p-3 border">
                    <p className="fw-bold fs-4 my-1">Rooming Report</p>
                    <div className="container text-center my-2">
                      <div
                        className="row"
                        style={{ backgroundColor: "#000000" }}
                      >
                        <div className="col border border-white text-white">
                          18th Dec
                        </div>
                        <div className="col border border-white text-white">
                          19th Dec
                        </div>
                        <div className="col border border-white text-white">
                          20th Dec
                        </div>
                        <div className="col border border-white text-white">
                          21st Dec
                        </div>
                        <div className="col border border-white text-white">
                          22nd Dec
                        </div>
                        <div className="col border border-white text-white">
                          23rd Dec
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ backgroundColor: "#e2e8f0" }}
                      >
                        <div className="col border border-white">
                          {" "}
                          {roomCount ? roomCount['18th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCount ? roomCount['19th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCount ? roomCount['20th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCount ? roomCount['21th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCount ? roomCount['22th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCount ? roomCount['23th'] : "0"}
                        </div>
                        {/* <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div> */}
                      </div>
                    </div>
                  </div>
                </div>

                       <div className="col-lg-12">
                  <div className="p-3 border">
                    <p className="fw-bold fs-4 my-1">Approved Buyers Rooming Report</p>
                    <div className="container text-center my-2">
                      <div
                        className="row"
                        style={{ backgroundColor: "#000000" }}
                      >
                        <div className="col border border-white text-white">
                          18th Dec
                        </div>
                        <div className="col border border-white text-white">
                          19th Dec
                        </div>
                        <div className="col border border-white text-white">
                          20th Dec
                        </div>
                        <div className="col border border-white text-white">
                          21st Dec
                        </div>
                        <div className="col border border-white text-white">
                          22nd Dec
                        </div>
                        <div className="col border border-white text-white">
                          23rd Dec
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ backgroundColor: "#e2e8f0" }}
                      >
                        <div className="col border border-white">
                          {" "}
                          {roomCountApproved ? roomCountApproved['18th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCountApproved ? roomCountApproved['19th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCountApproved ? roomCountApproved['20th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCountApproved ? roomCountApproved['21th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCountApproved ? roomCountApproved['22th'] : "0"}
                        </div>
                        <div className="col border border-white">
                          {" "}
                          {roomCountApproved ? roomCountApproved['23th'] : "0"}
                        </div>
                        {/* <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div> */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col-lg-6">
                <div className="p-3 border">
                  <p className="fw-bold fs-4 my-1">Vendor</p>
                  <div className="container text-center my-2">
                    <div className="row" style={{ backgroundColor: "#000000" }}>
                      <div className="col border border-white text-white">
                        Registered Staff
                      </div>
                      <div className="col border border-white text-white">
                        Approved Staff
                      </div>
                      <div className="col border border-white text-white">
                        Pending Staff
                      </div>
                    </div>
                    <div className="row" style={{ backgroundColor: "#e2e8f0" }}>
                      <div className="col border border-white">
                        {" "}
                        {vendorStaff ? vendorStaff : "0"}
                      </div>
                      <div className="col border border-white">1</div>
                      <div className="col border border-white">2</div>
                    </div>
                  </div>
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default DashBoard;
